export function randomUUID() {
  return (
    (window.crypto.randomUUID != null && window.crypto.randomUUID()) || // https://stackoverflow.com/a/2117523/2800218
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      // @ts-expect-error
      (c ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    )
  );
}
